<template>
  <div class="vm-flex vm-justify-end vm-mt-4">
    <gsp-select
      v-if="isEnabled"
      :value="selectedEnv"
      @change="changeEnv($event.target.value)"
      class="env-selector"
    >
      <label slot="end">Environment</label>
      <gsp-option value="">Select Env</gsp-option>
      <gsp-option v-for="(env, index) in allEnv" :key="index" :value="env">
        {{ env.toUpperCase() }} {{ env == hostEnv ? '(Host Env)' :  ''}}
      </gsp-option>
    </gsp-select>
  </div>
</template>

<script setup>
import { inject } from "vue";

const { isEnabled, allEnv, selectedEnv, changeEnv, hostEnv } = inject("envSelector");
</script>
